<script>
import { mapActions } from "pinia";
import { defineComponent } from "vue";
import NxtTasksApp from '@nextories/vue-tasks/src/components/templates/NxtTasksApp.vue';
import {useContactsStore} from "@nextories/vue-tasks/src/store/contactsStore.ts";
import {useQuotesStore} from "@nextories/vue-tasks/src/store/quotesStore.ts";
import {useUsersStore} from "@nextories/vue-tasks/src/store/usersStore.ts";

export default defineComponent({
  extends: NxtTasksApp,
  methods: {
    ...mapActions(useContactsStore, ['setIsMailboxN2']),
    ...mapActions(useQuotesStore, ['setRefDate']),
    ...mapActions(useUsersStore, [
      "setIsAssignedProjectUser",
      "setIsNewTaskAssignedProjectUser",
      "setIsAssignedNotUser",
    ]),
    async initApp() {
      try {
        await this.getUsers();
        await this.initHistory();
        await this.setInitialNotesFilters();
        this.setIsAssignedProjectUser(true);
        this.setIsNewTaskAssignedProjectUser(false);
        this.setIsMailboxN2(true);
        this.setRefDate('comp_sent_last');
        if (this.currentUser && !this.currentUser.is_admin) {
          this.setIsAssignedNotUser(false);
        }
        if (this.isLocationProjects && !this.isLoadedProjects) {
          await this.initProjects();
        } else if (this.isLocationMovers && !this.isLoadedMovers) {
          await this.initMovers();
        } else if (this.isLocationDiary && !this.isLoadedDiary) {
          await this.initDiary();
        } else if ((this.isLocationHistory || this.isLocationHomeProject || this.isLocationLogin)
          && !this.isLoadedTasks) {
          await this.initTasks(this.isLocationLogin);
        }
      } catch (error) {
        this.redirectToLogin(error);
        console.error(error);
      }
    },
  },
});
</script>

<template>
  <nxt-tasks-easter-egg-rotate v-if="isInit" class="app__wrapper">
    <nxt-tasks-layout :root-store="rootStore" class="app__layout">
      <RouterView/>
    </nxt-tasks-layout>
  </nxt-tasks-easter-egg-rotate>
  <div v-else class="app__wrapper">
    <loader :class="$vClass('loading')"
            :text="$t('base.loading')"
            sizeLoader="--size-small"/>
  </div>
</template>


<style lang="scss">
@use '@nextories/vue-tasks/src/assets/scss/app';

#app {
  .navbar,
  .navbar .el-submenu__title:hover {
    background-color: var(--nxt-color-athens-grayapprox);
  }
}
</style>
